import React, { useState ,useMemo} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";


import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
const NAVY = "#0b2d6e";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    padding: theme.spacing(2),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //  border: "2px solid #000",
    // boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
    maxWidth: 420,
    outline: "none",
    width: "100%",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 24px 60px rgba(11, 45, 110, 0.28)",
  },
  header: {
    background: NAVY,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 12px 14px 24px",
  },
  title: { margin: 0, fontSize: 18, fontWeight: 600, letterSpacing: 0.2 },
  closeBtn: {
    color: "#fff",
    "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" },
  },
  body: {
    padding: "20px 24px 8px",
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  hint: { fontSize: 13, color: "#5b6577", marginBottom: 2 },
  field: {
    "& .MuiOutlinedInput-root": { borderRadius: 8, backgroundColor: "#fff" },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: NAVY,
      borderWidth: 2,
    },
    "& .MuiInputLabel-outlined.Mui-focused": { color: NAVY },
  },
  meter: { display: "flex", gap: 4, marginTop: -4 },
  meterBar: {
    flex: 1,
    height: 4,
    borderRadius: 2,
    backgroundColor: "#e3e7ee",
    transition: "background-color 0.2s",
  },
  rules: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "4px 12px",
  },
  rule: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12.5,
    color: "#8a94a6",
    transition: "color 0.2s",
  },
  ruleOk: { color: "#1b7f4b" },
  ruleIcon: { fontSize: 16 },
  mismatch: { fontSize: 12.5, color: "#c62828", marginTop: -8 },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    padding: "12px 24px 20px",
  },
  cancel: {
    textTransform: "none",
    fontWeight: 600,
    color: "#3b4658",
    borderRadius: 8,
  },
  update: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "6px 22px",
    backgroundColor: NAVY,
    color: "#fff",
    boxShadow: "none",
    "&:hover": { backgroundColor: "#082357", boxShadow: "none" },
    "&.Mui-disabled": { backgroundColor: "#c9d0dd", color: "#fff" },
  },
}));

const RULES = [
  { key: "len", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { key: "upper", label: "One uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { key: "num", label: "One number", test: (p) => /\d/.test(p) },
  {
    key: "special",
    label: "One special character",
    test: (p) => /[^A-Za-z0-9]/.test(p),
  },
];

const STRENGTH_COLORS = ["#e3e7ee", "#e53935", "#fb8c00", "#fdd835", "#43a047"];

export default function ChangePasswordModal({
  openModal,
  setOpenModal,
  currentPassword,
  newPassword,
  confirmPassword,
  setcurrentPassword,
  setnewPassword,
  setconfirmPassword,
  changepasswordhandler,
}) {
  const classes = useStyles();
  const [show, setShow] = useState({
    new: false,
    old: false,
    confirm: false,
  });
  const passed = useMemo(
    () => RULES.map((r) => r.test(newPassword || "")),
    [newPassword],
  );
  const score = passed.filter(Boolean).length;
  const allRulesMet = score === RULES.length;
  const mismatch =
    confirmPassword.length > 0 && confirmPassword !== newPassword;
  const canSubmit =
    currentPassword.length > 0 &&
    allRulesMet &&
    confirmPassword === newPassword;
  const handleClose = () => {
    setcurrentPassword("");
    setconfirmPassword("");
    setnewPassword("");
    setOpenModal(false);
    setShow({ old: false, new: false, confirm: false });
  };
  const handleShowPassword = (type) => {
    if (type === "old") {
      setShow({ ...show, old: !show.old });
    } else if (type === "new") {
      setShow({ ...show, new: !show.new });
    } else if (type === "confirm") {
      setShow({ ...show, confirm: !show.confirm });
    }
  };

   const toggle = (key) => setShow((s) => ({ ...s, [key]: !s[key] }));

   const handleSubmit = (e) => {
     e.preventDefault();
     if (canSubmit) changepasswordhandler(e);
   };

   const eye = (key) => ({
     endAdornment: (
       <InputAdornment position="end">
         <IconButton
           size="small"
           edge="end"
           aria-label={show[key] ? "Hide password" : "Show password"}
           onClick={() => toggle(key)}
           onMouseDown={(e) => e.preventDefault()}
         >
           {show[key] ? <VisibilityOffIcon /> : <VisibilityIcon />}
         </IconButton>
       </InputAdornment>
     ),
   });
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={openModal}>
          <div className={classes.paper}>
            <div
              style={{
                background: "#0b2d6e",
                borderTopRightRadius: "10px",
                borderTopLeftRadius: "10px",
              }}
            >
              <Grid
                container
                direction="row"
                //alignItems="flex-start"
                justifyContent="space-between"
                spacing={1}
                item={12}
              >
                <Grid item={5}>
                  <h5
                    id="transition-modal-title"
                    style={{ marginLeft: "10px", marginTop: "10px",color:"white" }}
                  >
                    Change Password
                  </h5>
                </Grid>
                <Grid item={3} justifyContent="flex-end">
                  <IconButton onClick={handleClose} style={{color:"#fff"}}>
                    <CloseIcon color="#fff"/>
                  </IconButton>
                </Grid>
              </Grid>
            </div>
            <div autoComplete="off">
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                item={12}
              >
                <Grid
                  item={12}
                  style={{
                    marginTop: "10px",
                    marginLeft: "10px",
                    width: "70%",
                  }}
                ></Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>Old Password</Typography>

                    <TextField
                      className="user"
                      id="old-password"
                      name="old-password"
                      type={show.old ? "text" : "password"}
                      value={currentPassword}
                      onChange={(e) => setcurrentPassword(e.target.value)}
                      variant="outlined"
                      autoComplete="old-password"
                      inputProps={{ autoComplete: "old-password" }}
                      style={{ backgroundColor: "white" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => handleShowPassword("old")}>
                              {!show.old ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>New Password</Typography>

                    <TextField
                      className="user"
                      type={show.new ? "text" : "password"}
                      value={newPassword}
                      onChange={(e) => setnewPassword(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleShowPassword("new")}
                            >
                              {!show.new ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      id="new-password"
                      name="new-password"
                      autoComplete="new-password"
                      inputProps={{ autoComplete: "new-password" }}
                    />
                  </Typography>
                </Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>Confirm Password</Typography>

                    <TextField
                      className="user"
                      type={show.confirm ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setconfirmPassword(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleShowPassword("confirm")}
                            >
                              {!show.confirm ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      id="confirm-password"       // 👈 was "datetime-local"
                      name="confirm-password"     // 👈 was "fromDate"
                      autoComplete="new-password"
                      inputProps={{ autoComplete: "new-password" }}
                    />
                  </Typography>
                </Grid>

                <Grid
                  item={3}
                  style={{
                    margin: "10px 10px",
                    position: "relative",
                    left: "68%",
                  }}
                >
                  <Typography>
                    <Button variant="contained" onClick={changepasswordhandler}>
                      Update
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </div>
        </Fade> */}

         <Fade in={openModal}>
        <div className={classes.paper}>
          <div className={classes.header}>
            <h5 id="change-password-title" className={classes.title}>
              Change Password
            </h5>
            <IconButton
              className={classes.closeBtn}
              onClick={handleClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </div>

          <form onSubmit={handleSubmit} autoComplete="off" noValidate>
            <div className={classes.body}>
              <Typography className={classes.hint}>
                Enter your current password, then choose a new one.
              </Typography>

              <TextField
                className={classes.field}
                label="Old password"
                id="old-password"
                name="old-password"
                type={show.old ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setcurrentPassword(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                autoFocus
                InputProps={eye("old")}
                inputProps={{ autoComplete: "current-password" }}
              />

              <TextField
                className={classes.field}
                label="New password"
                id="new-password"
                name="new-password"
                type={show.new ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setnewPassword(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                InputProps={eye("new")}
                inputProps={{ autoComplete: "new-password" }}
              />

              {newPassword.length > 0 && (
                <>
                  <div className={classes.meter} aria-hidden="true">
                    {RULES.map((_, i) => (
                      <span
                        key={i}
                        className={classes.meterBar}
                        style={{
                          backgroundColor:
                            i < score ? STRENGTH_COLORS[score] : undefined,
                        }}
                      />
                    ))}
                  </div>
                  <ul className={classes.rules}>
                    {RULES.map((r, i) => (
                      <li
                        key={r.key}
                        className={`${classes.rule} ${
                          passed[i] ? classes.ruleOk : ""
                        }`}
                      >
                        {passed[i] ? (
                          <CheckCircleIcon className={classes.ruleIcon} />
                        ) : (
                          <RadioButtonUncheckedIcon className={classes.ruleIcon} />
                        )}
                        {r.label}
                      </li>
                    ))}
                  </ul>
                </>
              )}

              <TextField
                className={classes.field}
                label="Confirm password"
                id="confirm-password"
                name="confirm-password"
                type={show.confirm ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setconfirmPassword(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                error={mismatch}
                InputProps={eye("confirm")}
                inputProps={{ autoComplete: "new-password" }}
              />
              {mismatch && (
                <Typography className={classes.mismatch} role="alert">
                  Passwords don't match.
                </Typography>
              )}
            </div>

            <div className={classes.footer}>
              <Button className={classes.cancel} onClick={handleClose}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                className={classes.update}
                disabled={!canSubmit}
              >
                Update password
              </Button>
            </div>
          </form>
        </div>
      </Fade>
      </Modal>
    </div>
  );
}
